import { render, staticRenderFns } from "./TextInput.vue?vue&type=template&id=22480347&scoped=true&"
import script from "./TextInput.vue?vue&type=script&lang=ts&"
export * from "./TextInput.vue?vue&type=script&lang=ts&"
import style0 from "./TextInput.vue?vue&type=style&index=0&id=22480347&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22480347",
  null
  
)

export default component.exports